import React__default from 'react';
import { Loader } from '@grandvisionhq/common';

const DeliveryIndicatorLoader = ()=>/*#__PURE__*/ React__default.createElement("div", {
        className: "delivery-indicator delivery-indicator-loader"
    }, /*#__PURE__*/ React__default.createElement(Loader, {
        className: "delivery-indicator-loader__loader"
    }))
;

export { DeliveryIndicatorLoader };
//# sourceMappingURL=DeliveryIndicatorLoader.js.map
